import AddNew from "./AddNew";
import Receivings from "./Receivings";

export default { AddNew, Receivings };
